import { ModalDrawer } from '@egw/components'
import { type EnrollmentFixedIncomeRecommendationOutput } from '@egw/api/src/models/enrollment/enrollment'
import { type Dispatch, type SetStateAction, type ChangeEvent, type FC, useEffect } from 'react'
import { FixedIncome } from '../fixed-income/fixed-income'
import { ExperienceName } from '../../constants/api/experience-name'
import { type RiskTolerance } from '../modal-risk-tolerance/modal-risk-tolerance'

interface FixedIncomeProps {
  isOpen: boolean
  onClose: () => void
  riskTolerance?: RiskTolerance
  initEquityData: EnrollmentFixedIncomeRecommendationOutput[] | undefined
  sliderData?: EnrollmentFixedIncomeRecommendationOutput[] | undefined
  handleContinueClick: () => void
  setData?: Dispatch<SetStateAction<EnrollmentFixedIncomeRecommendationOutput[] | undefined>>
  withContainer?: boolean
  isShowCurrentValue?: boolean
  experience?: string
}

export const ModalFixedIncome: FC<FixedIncomeProps> = ({
  isOpen,
  onClose,
  riskTolerance,
  sliderData,
  setData,
  handleContinueClick,
  initEquityData,
  experience = ExperienceName.BBQ,
}) => {
  const onChangeSliders = (index: number, event: ChangeEvent<HTMLInputElement>): void => {
    const newValue = Number(event.target.value)

    setData?.((prevState) =>
      prevState?.map((slider, i) =>
        i === index
          ? {
              ...slider,
              currentAllocationPercent: newValue,
              recommendedRange: {
                ...slider.recommendedRange,
              },
            }
          : slider,
      ),
    )
  }

  const handleCloseModal = (): void => {
    setData?.(initEquityData)
    onClose()
  }

  return (
    <ModalDrawer isOpen={isOpen} title="" onClose={handleCloseModal} testId="fixed-income-modal">
      <FixedIncome
        riskTolerance={riskTolerance}
        sliderData={sliderData}
        onChangeSliders={onChangeSliders}
        withContainer={false}
        isShowCurrentValue
        handleContinueClick={() => {
          handleContinueClick()
        }}
        experience={experience}
      />
    </ModalDrawer>
  )
}
